// extracted by mini-css-extract-plugin
export var author = "page-intro-module--author--8bf76";
export var category = "page-intro-module--category--0b4f8";
export var headline = "page-intro-module--headline--f85a7";
export var headlinePost = "page-intro-module--headline-post--88349";
export var pageIntro = "page-intro-module--page-intro--13261";
export var pageIntro__headline = "page-intro-module--page-intro__headline--2727f";
export var pageIntro__text = "page-intro-module--page-intro__text--e7dd5";
export var paragraph = "page-intro-module--paragraph--4ffae";